import { render, staticRenderFns } from "./cuxiao.vue?vue&type=template&id=4012ea4b&scoped=true&"
import script from "./cuxiao.vue?vue&type=script&lang=js&"
export * from "./cuxiao.vue?vue&type=script&lang=js&"
import style0 from "./cuxiao.vue?vue&type=style&index=0&id=4012ea4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4012ea4b",
  null
  
)

export default component.exports